/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Maps internal BlogPost fields to external JSON field names. Keys are internal fields, values are the field name (or dot-path) in the external JSON.
 * @export
 * @interface BlogFieldMap
 */
export interface BlogFieldMap {
    /**
     * 
     * @type {string}
     * @memberof BlogFieldMap
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof BlogFieldMap
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof BlogFieldMap
     */
    summary?: string;
    /**
     * 
     * @type {string}
     * @memberof BlogFieldMap
     */
    content?: string;
    /**
     * 
     * @type {string}
     * @memberof BlogFieldMap
     */
    image_main?: string;
    /**
     * 
     * @type {string}
     * @memberof BlogFieldMap
     */
    image_thumbnail?: string;
    /**
     * 
     * @type {string}
     * @memberof BlogFieldMap
     */
    date?: string;
    /**
     * 
     * @type {string}
     * @memberof BlogFieldMap
     */
    date_updated?: string;
    /**
     * 
     * @type {string}
     * @memberof BlogFieldMap
     */
    author?: string;
}

/**
 * Check if a given object implements the BlogFieldMap interface.
 */
export function instanceOfBlogFieldMap(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function BlogFieldMapFromJSON(json: any): BlogFieldMap {
    return BlogFieldMapFromJSONTyped(json, false);
}

export function BlogFieldMapFromJSONTyped(json: any, ignoreDiscriminator: boolean): BlogFieldMap {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'title': !exists(json, 'title') ? undefined : json['title'],
        'summary': !exists(json, 'summary') ? undefined : json['summary'],
        'content': !exists(json, 'content') ? undefined : json['content'],
        'image_main': !exists(json, 'image_main') ? undefined : json['image_main'],
        'image_thumbnail': !exists(json, 'image_thumbnail') ? undefined : json['image_thumbnail'],
        'date': !exists(json, 'date') ? undefined : json['date'],
        'date_updated': !exists(json, 'date_updated') ? undefined : json['date_updated'],
        'author': !exists(json, 'author') ? undefined : json['author'],
    };
}

export function BlogFieldMapToJSON(value?: BlogFieldMap | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'title': value.title,
        'summary': value.summary,
        'content': value.content,
        'image_main': value.image_main,
        'image_thumbnail': value.image_thumbnail,
        'date': value.date,
        'date_updated': value.date_updated,
        'author': value.author,
    };
}

